module.exports = __webpack_public_path__ + "static/media/message.a74e0082.svg";